import styled from 'styled-components';

export const Disconnected = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 12px;
  img {
    max-height: 20px;
  }
`;
